(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capsule-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCapsuleWord(wordEl) {
      var raw = wordEl.getAttribute('data-words') || '';
      var words = raw.split('|').filter(Boolean);
      if (words.length < 2) return;

      var index = 0;

      function swap() {
        wordEl.classList.add('out');
        wordEl.classList.remove('in');
        setTimeout(function () {
          index = (index + 1) % words.length;
          wordEl.textContent = words[index];
          wordEl.classList.remove('out');
          wordEl.classList.add('in');
        }, 350);
      }

      setInterval(swap, 3000);
    }

    document.querySelectorAll('.cap-w').forEach(initCapsuleWord);

    // iOS Low Power Mode blocks autoplay: the poster stays visible and a first touch retries playback.
    document.querySelectorAll('.cap-vid').forEach((video) => {
      video.play().catch(() => {});
      window.addEventListener('touchstart', () => { video.play().catch(() => {}); }, { once: true, passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.ci-qty').forEach((wrap) => {
    const input = wrap.querySelector('.ci-qty-input');
    wrap.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.qtyStep, 10);
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-category"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-section]').forEach((sec) => {
    sec.querySelectorAll('.faq-q').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const isOpen = item.classList.contains('open');
        sec.querySelectorAll('.faq-item').forEach((i) => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-pills"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const t = document.querySelector(a.getAttribute('href'));
      if (t) {
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const nav = document.getElementById('nav');
  const ham = document.getElementById('ham');
  const mmenu = document.getElementById('mmenu');
  const mmBackdrop = document.getElementById('mm-backdrop');
  const mmClose = document.getElementById('mm-close');
  const mmShopToggle = document.getElementById('mm-shop-toggle');
  const mmSub = document.getElementById('mm-sub');
  const shopBtn = document.getElementById('shopbtn');
  const shopDropdown = document.getElementById('shopdd');
  const topbar = document.getElementById('topbar');

  function openMobileMenu() {
    mmenu.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mmenu.classList.remove('on');
    document.body.style.overflow = '';
  }

  if (ham) ham.addEventListener('click', openMobileMenu);
  if (mmBackdrop) mmBackdrop.addEventListener('click', closeMobileMenu);
  if (mmClose) mmClose.addEventListener('click', closeMobileMenu);
  if (mmShopToggle) {
    mmShopToggle.addEventListener('click', (e) => {
      e.preventDefault();
      mmSub.classList.toggle('on');
    });
  }

  if (shopBtn && shopDropdown) {
    shopBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      shopDropdown.classList.toggle('on');
    });
    document.addEventListener('click', () => shopDropdown.classList.remove('on'));
  }

  document.querySelectorAll('[data-acc-wrap]').forEach((wrap) => {
    const account = wrap.querySelector('shopify-account');
    if (!account) return;
    wrap.addEventListener('click', (e) => {
      if (e.target.closest('shopify-account')) return;
      const btn = account.shadowRoot && account.shadowRoot.querySelector('.account-button');
      if (btn) btn.click();
    });
  });

  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (topbar) topbar.classList.toggle('gone', y > 8);
    if (nav) {
      nav.classList.toggle('up', y > 8);
      nav.classList.toggle('pill', y > 60);
    }
  }, { passive: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const heroWrap = document.querySelector('.hero .h-wrap');
  const heroSection = document.querySelector('.hero');

  if (heroWrap && heroSection) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const h = heroSection.offsetHeight;
      const p = Math.min(y / h, 1);
      heroWrap.style.transform = `scale(${1 + p * 0.08}) translateY(${(y * 0.3) / (1 + p * 0.08)}px)`;
    }, { passive: true });
  }

  // Reveal the video only once it is actually playing; otherwise the fallback image stays visible
  // (e.g. iOS Low Power Mode blocks autoplay).
  document.querySelectorAll('.hero .h-video').forEach((video) => {
    const markPlaying = () => video.classList.add('is-playing');
    video.addEventListener('playing', markPlaying);
    if (!video.paused && video.readyState > 2) markPlaying();
    video.play().catch(() => {});
    // A first touch counts as a user gesture, which lets Low Power Mode play the video.
    const retry = () => { video.play().catch(() => {}); };
    window.addEventListener('touchstart', retry, { once: true, passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-panel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ing-facts-btn').forEach((btn) => {
    const modal = document.getElementById(btn.dataset.factsTrigger);
    if (!modal) return;
    const open = () => {
      modal.classList.add('on');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      modal.classList.remove('on');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    btn.addEventListener('click', open);
    modal.querySelectorAll('[data-facts-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["os-parallax"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.os-parallax-bg').forEach((bg) => {
    window.addEventListener('scroll', () => {
      const rect = bg.parentElement.getBoundingClientRect();
      const p = -rect.top * 0.25;
      bg.style.transform = `translateY(${p}px)`;
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.buy-sec').forEach((sec) => {
    const mainImg = sec.querySelector('.gal-main img');
    const thumbs = sec.querySelectorAll('.gal-th');
    thumbs.forEach((th) => {
      th.addEventListener('click', () => {
        if (!mainImg || !th.dataset.galSrc) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = th.dataset.galSrc;
        thumbs.forEach((t) => t.classList.remove('on'));
        th.classList.add('on');
      });
    });

    // Price shown above the form follows the selected variant and the purchase option (one-time vs subscription).
    const dataEl = sec.querySelector('[data-buy-data]');
    const priceEl = sec.querySelector('[data-buy-price]');
    const idInput = sec.querySelector('input[name="id"]');
    const cta = sec.querySelector('.buy-cta');
    let buyData = null;
    try { buyData = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) {}
    function refreshPrice() {
      if (!buyData || !priceEl || !idInput) return;
      const v = buyData.variants[idInput.value];
      if (!v) return;
      const planInput = sec.querySelector('input[name="selling_plan"]:checked');
      const subscribed = planInput && planInput.value && v.plan_price;
      if (subscribed && v.plan_cents < v.cents) {
        priceEl.innerHTML = v.plan_price + ' <span class="buy-price-old">' + v.price + '</span>';
      } else if (subscribed) {
        priceEl.textContent = v.plan_price;
      } else {
        priceEl.textContent = v.price;
      }
      const oneTime = sec.querySelector('[data-buy-onetime]');
      if (oneTime) oneTime.textContent = v.price;
      if (cta) cta.disabled = !v.available;
    }

    sec.querySelectorAll('.buy-opts').forEach((group) => {
      group.querySelectorAll('.buy-opt').forEach((opt) => {
        opt.addEventListener('click', () => {
          group.querySelectorAll('.buy-opt').forEach((o) => o.classList.remove('on'));
          opt.classList.add('on');
          const input = opt.querySelector('input[type="radio"]');
          if (input) input.checked = true;
          if (input && input.dataset.variantId && idInput) idInput.value = input.dataset.variantId;
          refreshPrice();
        });
      });
    });
    refreshPrice();

    sec.querySelectorAll('[data-acdn-toggle]').forEach((h) => {
      h.addEventListener('click', () => {
        const item = document.getElementById(h.dataset.acdnToggle);
        if (!item) return;
        const parent = item.parentElement;
        parent.querySelectorAll('.acdn-item').forEach((i) => { if (i !== item) i.classList.remove('open'); });
        item.classList.toggle('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pfaq-section]').forEach((sec) => {
    sec.querySelectorAll('[data-pfaq-toggle]').forEach((h) => {
      h.addEventListener('click', () => {
        const item = h.closest('.acdn-item');
        const isOpen = item.classList.contains('open');
        sec.querySelectorAll('.acdn-item').forEach((i) => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sp-outer').forEach((outer) => {
    const track = outer.querySelector('.sp-track');
    const txt = outer.querySelector('.sp-txt');
    if (!track) return;

    const canHover = window.matchMedia('(hover: hover)').matches;
    const scroller = outer.querySelector('.sp-tw');
    // Touch devices: the row keeps sliding on its own, pauses while the visitor touches it or a video plays,
    // and resumes a moment after they let go.
    function startTouchAutoScroll(loopWidth) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const speed = loopWidth / 76; // px per second, same pace as the desktop loop
      let pos = scroller.scrollLeft, last = 0, touching = false, resumeAt = 0;
      const hold = (ms) => { resumeAt = performance.now() + ms; };
      scroller.addEventListener('touchstart', () => { touching = true; }, { passive: true });
      scroller.addEventListener('touchend', () => { touching = false; hold(2500); }, { passive: true });
      scroller.addEventListener('touchcancel', () => { touching = false; hold(2500); }, { passive: true });
      function tick(now) {
        const dt = last ? Math.min((now - last) / 1000, 0.1) : 0;
        last = now;
        const playing = track.querySelector('.sp-card.sp-playing');
        if (!touching && !playing && now >= resumeAt) {
          if (Math.abs(scroller.scrollLeft - Math.floor(pos)) > 2) pos = scroller.scrollLeft;
          pos += speed * dt;
          if (pos >= loopWidth) pos -= loopWidth;
          scroller.scrollLeft = Math.floor(pos);
        } else {
          pos = scroller.scrollLeft;
          if (playing) hold(2500);
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    let loopDone = false;
    function initLoop() {
      // Touch devices get a native swipe-scrolling row instead of the auto-sliding loop.
      if (loopDone) return;
      loopDone = true;
      track.innerHTML = track.innerHTML + track.innerHTML;
      const sw = track.scrollWidth / 2;
      if (!canHover) { startTouchAutoScroll(sw); return; }
      const style = document.createElement('style');
      style.textContent = `@keyframes sp-slide-${track.id}{0%{transform:translateX(0)}100%{transform:translateX(-${sw}px)}}#${track.id}{animation:sp-slide-${track.id} 76s linear infinite}#${track.id}:hover{animation-play-state:paused}`;
      document.head.appendChild(style);
    }
    function cardOf(el) { return el && el.closest ? el.closest('.sp-card[data-video]') : null; }
    function play(card) {
      const v = card.querySelector('video');
      if (!v) return;
      track.querySelectorAll('.sp-card.sp-playing').forEach((c) => { if (c !== card) stop(c); });
      v.muted = false;
      v.play().then(() => card.classList.add('sp-sound')).catch(() => {
        // Browser blocks sound until the visitor has interacted with the page: fall back to muted.
        v.muted = true;
        card.classList.remove('sp-sound');
        v.play().catch(() => {});
      });
      card.classList.add('sp-playing');
      track.classList.add('sp-paused');
      if (!canHover && 'IntersectionObserver' in window) {
        // On touch the video keeps playing while swiping, and stops once its card scrolls out of view.
        if (card._spIO) card._spIO.disconnect();
        card._spIO = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) stop(card);
        }, { root: scroller, threshold: 0.2 });
        card._spIO.observe(card);
      }
    }
    function stop(card) {
      const v = card.querySelector('video');
      if (v) { v.pause(); v.muted = true; }
      card.classList.remove('sp-playing', 'sp-sound');
      if (card._spIO) { card._spIO.disconnect(); card._spIO = null; }
      if (!track.querySelector('.sp-card.sp-playing')) track.classList.remove('sp-paused');
    }
    track.addEventListener('timeupdate', (e) => {
      const v = e.target;
      const card = cardOf(v);
      if (!card || !v.duration) return;
      const bar = card.querySelector('.sp-vb-prog');
      const t = card.querySelector('.sp-vb-time');
      if (bar) bar.style.width = (v.currentTime / v.duration * 100) + '%';
      if (t) { const r = Math.max(0, Math.ceil(v.duration - v.currentTime)); t.textContent = Math.floor(r / 60) + ':' + String(r % 60).padStart(2, '0'); }
    }, true);
    if (canHover) {
      track.addEventListener('mouseenter', (e) => { const c = cardOf(e.target); if (c) play(c); }, true);
      track.addEventListener('mouseleave', (e) => { const c = cardOf(e.target); if (c) stop(c); }, true);
      track.addEventListener('click', (e) => {
        const c = cardOf(e.target);
        const v = c && c.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        c.classList.toggle('sp-sound', !v.muted);
      });
    } else {
      track.addEventListener('click', (e) => {
        const c = cardOf(e.target);
        if (!c) return;
        if (c.classList.contains('sp-playing')) { stop(c); } else { const v = c.querySelector('video'); if (v) v.muted = false; play(c); c.classList.add('sp-sound'); }
      });
    }
    window.addEventListener('load', () => setTimeout(initLoop, 100));
    setTimeout(initLoop, 800);

    if (txt && window.innerWidth > 768) {
      window.addEventListener('scroll', () => {
        const r = outer.getBoundingClientRect();
        const total = outer.offsetHeight;
        const p = Math.max(0, Math.min(1, -r.top / total));
        txt.style.transform = `translateX(-50%) translateY(${-p * 80}px)`;
      }, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
